import classNames from 'classnames';

interface IconProps {
    className?: string | null;
}

function Ordinateur({ className = null }: IconProps) {
    return (
        <svg
            className={classNames([{ [className]: className !== null }])}
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 239.06 144.1"
        >
            <defs>
                <filter
                    id="drop-shadow-ordinateur"
                    x="0"
                    y="0"
                    width="239.06"
                    height="144.1"
                    filterUnits="userSpaceOnUse"
                >
                    <feOffset dx="5" dy="5" />
                    <feGaussianBlur result="blur" stdDeviation="0" />
                    <feFlood floodColor="#000" floodOpacity="1" />
                    <feComposite in2="blur" operator="in" />
                    <feComposite in="SourceGraphic" />
                </filter>
            </defs>
            <polygon
                points="50.95 121.41 2.7 83.3 64.1 80.12 51.64 19.91 100.72 56.94 129.88 2.81 143.67 62.72 200.8 40 172.86 94.76 231.23 114.08 174.62 138.07 50.95 121.41"
                fill="#928df7"
                filter="url(#drop-shadow-ordinateur)"
                stroke="#000"
                strokeMiterlimit="10"
                strokeWidth="2"
            />
        </svg>
    );
}

export default Ordinateur;
